export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200" id="footer">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-trophy-line text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading">
                每日大赛入口
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              每日大赛入口🔥内容介绍专题，涵盖每日大赛作品介绍、每日大赛类型、每日大赛列表及每日大全，帮你快速了解品牌特色与内容分类，发现感兴趣的各类大赛视频。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#hero" className="text-sm text-background-400 hover:text-background-100 transition-colors">首页</a></li>
              <li><a href="#ranking" className="text-sm text-background-400 hover:text-background-100 transition-colors">热门排行</a></li>
              <li><a href="#topics" className="text-sm text-background-400 hover:text-background-100 transition-colors">大赛类型</a></li>
              <li><a href="#cards" className="text-sm text-background-400 hover:text-background-100 transition-colors">图文精选</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">内容板块</h4>
            <ul className="space-y-2.5">
              <li><a href="#faq" className="text-sm text-background-400 hover:text-background-100 transition-colors">常见问答</a></li>
              <li><a href="#media" className="text-sm text-background-400 hover:text-background-100 transition-colors">精彩视频</a></li>
              <li><a href="#updates" className="text-sm text-background-400 hover:text-background-100 transition-colors">最新动态</a></li>
              <li><a href="#index" className="text-sm text-background-400 hover:text-background-100 transition-colors">专题索引</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">合作伙伴</h4>
            <p className="text-sm text-background-500">更多合作伙伴即将入驻，敬请期待。</p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 每日大赛入口 — 每日大赛作品介绍与每日大赛类型列表大全
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500">每日大赛入口官网</span>
            <span className="text-xs text-background-600">|</span>
            <span className="text-xs text-background-500">每日大赛在线平台</span>
          </div>
        </div>
      </div>
    </footer>
  );
}